import React from "react";
import './Maintenance.scss'

import TeacherLoadContainer from "root/s360components/TeacherLoad/TeacherLoadContainer";
import ReactAdminContainer from "root/s360components/Administration/ReactAdminContainer";
import UserEditContainer from "root/s360components/UserRename/UserEditContainer";
import MisStatusToolContainer from "root/s360components/WondeWebhookAdmin/MisStatusToolContainer";

const MaintenancePage = (props) =>
{
    return (
        <ReactAdminContainer>
            <TeacherLoadContainer />
            <UserEditContainer />
            <MisStatusToolContainer />
        </ReactAdminContainer>
    )
};

export default MaintenancePage;
